import React, { FC } from "react";

interface industryDataType {
    industryData: Array<string>;
}
const RelatedIndustries: FC<industryDataType> = ({ industryData }) => {
    // icons that are stored in s3
    const icons = [
        "ecommerce-icon.svg",
        "healthcare-icons.svg",
        "automobile-white.svg",
        "education-icon.svg",
        "popular-icons.svg",
        "travel-icons.svg",
        "real-estate-icons.svg",
        "finance.svg",
    ];
    const industryList = industryData
        .filter((d: string) => d !== "All")
        .map((each, i) => {
            return { name: each, image: icons[i] };
        });
    // console.log("industryDataaaa", industryList);
    const giveValidUrl = (name: any) => {
        let validName;
        if (Array.isArray(name)) {
            validName = name.map((each) => {
                return each.split(" ").join("-").toLowerCase();
            });
        } else {
            validName = name.split(" ").join("-").toLowerCase();
        }
        return validName;
    };

    return (
        <section className="px-5 py-10 md:py-16 " style={{ background: "linear-gradient(94.66deg, #3760DD 48.41%, #1B48D0 99.63%)" }}>
            <div className="mx-auto" style={{ maxWidth: "1250px" }}>
                <h3 className="m-0 p-0 text-white font-bold text-xl text-center md:text-left md:text-3xl pb-5 md:pb-10">Browse Bot Templates by Industry</h3>
                <div className="flex flex-col gap-5 md:gap-8 md:flex-row items-center md:justify-center">
                    {industryList.map((each) => {
                        if (each.name === "All") {
                            return null;
                        }

                        return (
                            <a
                                href={`/whatsapp-chatbot-templates/${each.name === "All" ? "" : giveValidUrl(each.name)}`}
                                className="hover:no-underline block w-fit"
                                key={each.name}
                            >
                                <div>
                                    <div className="w-32 h-32 industry-eachcard flex items-center justify-center">
                                        <div>
                                            <img src={`https://assets.gallabox.com/gb-home/bot-templates/icons/${each.image}`} alt="" />
                                        </div>
                                    </div>
                                    <p className="text-white text-center font-normal text-lg md:mt-4">{each.name}</p>
                                </div>
                            </a>
                        );
                    })}
                </div>
            </div>
            <style jsx>
                {`
                    .industry-eachcard {
                        background: #547eff;
                        border: 1.09923px solid #b4c0ea;
                        box-shadow: 0px 11.1476px 16.7214px -3.34428px rgba(0, 0, 0, 0.1), 0px 4.45904px 6.68856px -2.22952px rgba(0, 0, 0, 0.05);
                        border-radius: 6px;
                    }
                `}
            </style>
        </section>
    );
};
export default RelatedIndustries;
